export const EVENT_ORGANIZERS_METADATA_REQUESTED = 'eventOrganizers/METADATA_REQUESTED';
export const EVENT_ORGANIZERS_METADATA_SUCCESS = 'eventOrganizers/METADATA_SUCCESS';
export const EVENT_ORGANIZERS_METADATA_FAILURE = 'eventOrganizers/METADATA_FAILURE';

export const EVENT_ORGANIZERS_LIST_DATA_REQUESTED = 'eventOrganizers/LIST_REQUESTED';
export const EVENT_ORGANIZERS_LIST_DATA_SUCCESS = 'eventOrganizers/LIST_SUCCESS';
export const EVENT_ORGANIZERS_LIST_DATA_FAILURE = 'eventOrganizers/LIST_FAILURE';

export const EVENT_ORGANIZERS_CREATE_REQUESTED = 'eventOrganizers/CREATE_REQUESTED';
export const EVENT_ORGANIZERS_CREATE_SUCCESS = 'eventOrganizers/CREATE_SUCCESS';
export const EVENT_ORGANIZERS_CREATE_FAILURE = 'eventOrganizers/CREATE_FAILURE';

export const EVENT_ORGANIZERS_UPDATE_REQUESTED = 'eventOrganizers/UPDATE_REQUESTED';
export const EVENT_ORGANIZERS_UPDATE_SUCCESS = 'eventOrganizers/UPDATE_SUCCESS';
export const EVENT_ORGANIZERS_UPDATE_FAILURE = 'eventOrganizers/UPDATE_FAILURE';

export const EVENT_ORGANIZERS_GET_REQUESTED = 'eventOrganizers/GET_REQUESTED';
export const EVENT_ORGANIZERS_GET_SUCCESS = 'eventOrganizers/GET_SUCCESS';
export const EVENT_ORGANIZERS_GET_FAILURE = 'eventOrganizers/GET_FAILURE';

export const EVENT_ORGANIZERS_DELETE_REQUESTED = 'eventOrganizers/DELETE_REQUESTED';
export const EVENT_ORGANIZERS_DELETE_SUCCESS = 'eventOrganizers/DELETE_SUCCESS';
export const EVENT_ORGANIZERS_DELETE_FAILURE = 'eventOrganizers/DELETE_FAILURE';

export const EVENT_ORGANIZERS_MESSAGE_CLEAR = 'eventOrganizers/MESSAGE_CLEAR';
